import React from 'react'
import PlatformAuth from 'aldoo-ra/PlatformAuth'
import FileShareController from './FileShareController'
import MainBackground from "@components/MainBackground"

function FileSharePage() {
  const [auth] = PlatformAuth.useAuth()

  return (
    <>
      <div className="fixed inset-0 pointer-events-none">
        <MainBackground />
      </div>
      <div className="relative min-h-[calc(100vh-64px)] z-10">
        <FileShareController auth={auth} />
      </div>
    </>
  )
}

// AldooComponent definition for auto-discovery
export const AldooComponent = {
  id: "FileShareFeature",
  component: FileSharePage,
  description: "Aldoo Transfer file share home page — upload, share links, retention, access control.",
  input: {},
}

export default FileSharePage